module.exports = __webpack_public_path__ + "assets/img/trait2.a7e0d3fc.png";